import { render, staticRenderFns } from "./GoodsForm2.vue?vue&type=template&id=108e2aa1&scoped=true&"
import script from "./GoodsForm2.vue?vue&type=script&lang=js&"
export * from "./GoodsForm2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GoodsForm2.vue?vue&type=style&index=1&id=108e2aa1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e2aa1",
  null
  
)

export default component.exports